export const DEVICES_BY_STATUS_REQUEST = "DEVICES_BY_STATUS_REQUEST";
export const DEVICES_BY_STATUS_RESULT = "DEVICES_BY_STATUS_RESULT";